import React, { useState, useCallback, useEffect } from "react";
import { User, Menu, X } from "lucide-react";
import {
  FaPhone,
  FaRing,
  FaUserFriends,
  FaUsers,
  FaLandmark,
  FaBalanceScale,
  FaPassport,
  FaFileAlt,
  FaFlag,
  FaPlaneArrival,
  FaGraduationCap,
  FaBriefcase,
  FaGlobe,
  FaHome,
  FaCommentDots,
  FaShieldAlt,
  FaHeartbeat,
} from "react-icons/fa";
import { FaChildren } from "react-icons/fa6";

import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { BACKEND_URL_OUT, makeRequestAuth } from "../../../_config/api";

import BasicProfileForm from "../spouse/BasicProfileForm";
import ContactForm from "../spouse/ContactForm";
import PassportForm from "../spouse/PassportForm";
import CanadaForm from "../spouse/CanadaForm";
import VISAForm from "../spouse/VISAForm";
import FlightForm from "../spouse/FlightForm";
import MaritalForm from "../spouse/MaritalForm";
import ChildForm from "../spouse/ChildForm";
import ParentForm from "../spouse/ParentForm";
import SiblingForm from "../spouse/SiblingForm";
import EducationForm from "../spouse/EducationForm";
import EmploymentFrom from "../spouse/EmploymentFrom";
import AddressHistoryForm from "../spouse/AddressHistoryForm";
import TravelForm from "../spouse/TravelForm";
import CriminalitySecurityForm from "../spouse/CriminalitySecurityForm";
import MedicalHistoryForm from "../spouse/MedicalHistoryForm";
import PoliticalForm from "../spouse/PoliticalForm";
import LocalForm from "../spouse/LocalFrom";
import StatementForm from "../spouse/StatementForm";

const getEmptyVisa = () => ({
  appliedDate: "",
  appliedThrough: "",
  agentName: "",
  howYouFoundAgent: "",
  feesPaid: "",
  biometricDate: "",
  biometricCity: "",
  issueDate: "",
  expiryDate: "",
});

const emptyVisa = () => ({
  country: "",
  visaType: "",
  issueDate: "",
  expiryDate: "",
  denied: false,
  denialReason: "",
});

const emptyPassport = () => ({
  passportNumber: "",
  issueDate: "",
  expiryDate: "",
  remarks: "",
});

const createEmptyFlight = () => ({
  fromAirport: "",
  toAirport: "",
  airline: "",
  ticketNumber: "",
  transit: "",
  airportCharges: "",
});

const createEmptyChild = () => ({
  firstName: "",
  lastName: "",
  dob: "",
  gender: "",
  education: "",
  currentCountry: "",
  isAccompanying: false
});

const createEmptyParent = () => ({
  relation: "",
  name: "",
  surname: "",
  dateOfBirth: null, // Date object ke liye null set kiya
  dateOfDeath: null,
  placeOfBirth: "",
  currentAddress: "",
  isInCanada: false,
  canadaAddress: ""
});

const createEmptySibling = () => ({
  relation: "",
  name: "",
  surname: "",
  maritalStatus: "",
  dateOfBirth: "",
  dateOfDeath: "",
  placeOfBirth: "",
  currentAddress: "",
  isInCanada: false,
  canadaAddress: "",
});

const getEmptyEducation = () => ({
  level: "",
  schoolName: "",
  city: "",
  country: "",
  address: "",
  from: "",
  to: "",
});

const getEmptyWork = () => ({
  companyName: "",
  job: "",
  position: "",
  city: "",
  country: "",
  companyAddress: "",
  from: "",
  to: "",
});

const getEmptyAddress = () => ({
  address: "",
  country: "",
  from: "",
  to: "",
});

const EMPTY_TRAVEL = () => ({
  country: "",
  visaType: "",
  stayAddress: "",
  from: "",
  to: "",
});

const EMPTY_FORM = {
  committedCrime: false,
  arrestedForOffence: false,
  chargedForOffence: false,
  convictedForOffence: false,
  criminalDetails: {
    committedCrime: { date: "", reason: "", result: "" },
    arrestedForOffence: { date: "", reason: "", result: "" },
    chargedForOffence: { date: "", reason: "", result: "" },
    convictedForOffence: { date: "", reason: "", result: "" }
  }
};


const MEDICAL_FORM = {
  hasSeriousIllness: false,
  hasMentalDisorder: false,
  hasCommunicableDisease: false,
  requiresMedicalTreatment: false,
  medicalDetails: {
    hasSeriousIllness: { date: "", reason: "", result: "" },
    hasMentalDisorder: { date: "", reason: "", result: "" },
    hasCommunicableDisease: { date: "", reason: "", result: "" },
    requiresMedicalTreatment: { date: "", reason: "", result: "" }
  }
};

const emptyData = {
  supportedPartyYesNo: false,
  supportedPartyName: "",
  farmerOrgYesNo: false,
  farmerOrganisation: "",
  proKhalistanYesNo: false,
  proKhalistanSupport: "",
};

const localData = {
  sarpanchOrMLA: "",
  partyName: "",
  partyOfficeAddress: "",
  policeASI: "",
  policeHawaldar: "",
  nearbyHospital: "",
  stateGovernment: {
    party: "",
    cmName: "",
  },
};

const getEmptyBlock = () => ({
  language: "",
  description: "",
  files: [],
});




const SpouseForm = () => {
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [activeTab, setActiveTab] = useState("basicProfile");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const scrollRef = useRef(null);

  const [canada, setCanada] = useState([getEmptyVisa()]);
  const [visas, setVisas] = useState([emptyVisa()]);
  const [oldPassports, setOldPassports] = useState({
    hasOldPassport: false,
    passports: [emptyPassport()],
  });
  const [flights, setFlights] = useState([createEmptyFlight()]);
  const [childs, setChilds] = useState([createEmptyChild()]);
  const [mode, setMode] = useState("edit");
  const [parents, setParents] = useState([createEmptyParent()]);
  const [siblings, setSiblings] = useState([createEmptySibling()]);
  const [education, setEducation] = useState([getEmptyEducation()]);
  const [workList, setWorkList] = useState([getEmptyWork()]);
  const [addresses, setAddresses] = useState([getEmptyAddress()]);
  const [travels, setTravels] = useState([EMPTY_TRAVEL()]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [medical, setMedical] = useState(MEDICAL_FORM);
  const [political, setPolitical] = useState(emptyData);
  const [local, setLocal] = useState(localData);
  const [statements, setStatements] = useState([getEmptyBlock()]);
  const [narratives, setNarratives] = useState([getEmptyBlock()]);
  const [eSignatureText, setESignatureText] = useState("");
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [signatureUploading, setSignatureUploading] = useState(false);


  console.log('previewData', previewData);

  useEffect(() => {
    fetchAPi();
  }, []);

  const fetchAPi = async () => {
    setLoading(true);
    try {
      const response = await makeRequestAuth("get", "/user/getSpouse");
      if (response.data) setPreviewData(response.data);
    } catch {
      setPreviewData(null);
    } finally {
      setLoading(false);
    }
  };


  const handleTabChange = (id) => {
    setActiveTab(id);
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const [formData, setFormData] = useState({});

  const handleChange = useCallback((arg1, arg2, arg3) => {

    // ✅ Case 1: (name, value)
    if (typeof arg1 === "string" && arg3 === undefined) {
      setFormData(prev => ({
        ...prev,
        [arg1]: arg2
      }));
      return;
    }

    // ✅ Case 2: (index, field, value) → arrays
    if (typeof arg1 === "number") {
      // ⚠️ You MUST decide which state to update
      // Example for visas:
      setVisas(prev => {
        const updated = [...prev];
        updated[arg1] = { ...updated[arg1], [arg2]: arg3 };
        return updated;
      });
      return;
    }

    // ✅ Case 3: event
    if (arg1?.target) {
      const { name, value, type, checked } = arg1.target;
      const finalValue = type === "checkbox" ? checked : value;

      setFormData(prev => ({
        ...prev,
        [name]: finalValue
      }));
    }

  }, []);

  const handleSiblingsChange = (index, field, value) => {
    setSiblings((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      if (field === "isInCanada" && !value) {
        updated[index].canadaAddress = "";
      }
      return updated;
    });
  };

  const handleVisaChange = (index, field, value) => {
    setVisas((prev) => {
      const list = [...prev];
      list[index] = { ...list[index], [field]: value };
      if (field === "denied" && !value) list[index].denialReason = "";
      return list;
    });
  };

  const updateChild = (index, field, value) => {
    setChilds(prev =>
      prev.map((c, i) => (i === index ? { ...c, [field]: value } : c))
    );
  };

  const handleOldPassportChange = (index, field, value) => {
    setOldPassports((prev) => {
      const passports = [...prev.passports];
      passports[index] = { ...passports[index], [field]: value };
      return { ...prev, passports };
    });
  };

  const handleFlightsChange = (index, field, value) => {
    setFlights((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleEducationChange = (index, field, value) => {
    const updated = [...education];
    updated[index][field] = value;

    if (field === "from" && updated[index].to && value > updated[index].to) {
      updated[index].to = "";
    }
    setEducation(updated);
  };

  const handleEmploymentChange = (index, field, value) => {
    const updated = [...workList];
    updated[index][field] = value;
    if (field === "from" && updated[index].to && value > updated[index].to) {
      updated[index].to = "";
    }
    setWorkList(updated);
  };

  const handleAddressHistoryChange = (index, field, value) => {
    setAddresses((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleTravelChange = (index, field, value) => {
    const updated = [...travels];
    updated[index] = { ...updated[index], [field]: value };

    if (field === "from" && updated[index].to && updated[index].to < value) {
      updated[index].to = "";
    }
    setTravels(updated);
  };

  const handleCriminalityChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCriminalityDetailChange = (type, field, value) => {
    setForm((prev) => ({
      ...prev,
      criminalDetails: { ...prev.criminalDetails, [type]: { ...prev.criminalDetails[type], [field]: value } }
    }));
  };

  const handleMedicalChange = (field, value) => {
    setMedical((prev) => ({ ...prev, [field]: value }));
  };

  const handleDetailMedicalChange = (type, field, value) => {
    setMedical((prev) => ({
      ...prev,
      medicalDetails: { ...prev.medicalDetails, [type]: { ...prev.medicalDetails[type], [field]: value } }
    }));
  };

  const handlePoliticalChange = (field, value) => {
    setPolitical({ ...political, [field]: value });
  };

  const handleLocalChange = (field, value) => {
    setLocal((prev) => ({ ...prev, [field]: value }));
  };

  const handleStateGovLocalChange = (subField, value) => {
    setLocal((prev) => ({
      ...prev,
      stateGovernment: { ...prev.stateGovernment, [subField]: value },
    }));
  };

  const updateParent = (index, field, value) => {
    setParents(prev =>
      prev.map((p, i) => (i === index ? { ...p, [field]: value } : p))
    );
  };

  const handleUpload = async (file) => {
    if (!file) return;

    if (file.size > 2 * 1024 * 1024) {
      showErrorToast("File must be under 2MB");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const fd = new FormData();
      fd.append("file", file);

      const res = await axios.post(
        `${BACKEND_URL_OUT}/uploadImage`,
        fd,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setFormData((prev) => ({
        ...prev,
        casteImageUrl: res?.data?.data?.imageUrl || "",
      }));

      showSuccessToast("Image uploaded successfully!");
    } catch (err) {
      console.error(err);
      showErrorToast("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const uploadFile = async (file) => {
    try {
      if (!file) {
        showErrorToast("No file selected");
        return null;
      }

      const token = localStorage.getItem("token");

      if (!token) {
        showErrorToast("Session expired. Please login again.");
        return null;
      }

      /* 🔥 Optional but VERY recommended */
      const MAX_SIZE = 5 * 1024 * 1024; // 5MB

      if (file.size > MAX_SIZE) {
        showErrorToast("File too large. Max size is 5MB.");
        return null;
      }

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
      ];

      if (!allowedTypes.includes(file.type)) {
        showErrorToast("Only JPG, PNG, and PDF files are allowed.");
        return null;
      }

      const formData = new FormData();
      formData.append("file", file);

      const res = await axios.post(
        `${BACKEND_URL_OUT}/uploadImage`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          timeout: 20000, // ⭐ prevents hanging requests
        }
      );

      showSuccessToast("File uploaded successfully ✅");

      return {
        url: res.data.data.imageUrl,
        fileName: file.name,
      };

    } catch (error) {

      /* ⭐ Axios Error Handling */
      if (error.response) {

        const status = error.response.status;

        switch (status) {

          case 401:
            showErrorToast("Session expired. Please login again.");
            localStorage.removeItem("token");
            window.location.href = "/login";
            break;

          case 413:
            showErrorToast("File is too large.");
            break;

          case 415:
            showErrorToast("Unsupported file type.");
            break;

          case 500:
            showErrorToast("Server error. Try again later.");
            break;

          default:
            showErrorToast(
              error.response?.data?.message ||
              "Upload failed. Please try again."
            );
        }

      } else if (error.request) {

        // request made but no response
        showErrorToast("Network error. Check your internet connection.");

      } else {

        // something else
        showErrorToast("Unexpected error occurred.");
      }

      console.error("UPLOAD ERROR:", error);

      return null;
    }
  };

  const uploadSignature = async (file) => {
    if (!file) return;
    setSignatureUploading(true);
    try {
      const uploaded = await uploadFile(file);
      if (!uploaded) return;
      setSignatureUrl(uploaded.url);
      showSuccessToast("Signature uploaded ✅");
    } catch {
      showErrorToast("Signature upload failed ❌");
    } finally {
      setSignatureUploading(false);
    }
  };

  const updateList = (setter) => (index, field, value) => {
    setter((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleFileUpload = async (file, index, setter) => {
    if (!file) return;

    try {
      const uploaded = await uploadFile(file);

      // ✅ STOP if upload failed
      if (!uploaded) return;

      setter((prev) => {
        const updated = [...prev];
        updated[index].files = [...(updated[index].files || []), uploaded];
        return updated;
      });

      showSuccessToast("File uploaded ✅");

    } catch {
      showErrorToast("Upload failed ❌");
    }
  };



  if (previewData) {

    const status = previewData?.status || "pending";

    const statusConfig = {
      pending: {
        title: "⏳ Application Under Review",
        color: "text-yellow-600",
        bg: "bg-yellow-50 border-yellow-200",
        message: `You have successfully submitted your details.
Your application is currently under review by the admin.
You will be notified once the review is complete.`
      },
      approved: {
        title: "✅ Application Approved",
        color: "text-green-600",
        bg: "bg-green-50 border-green-200",
        message: `Congratulations!
Your application has been approved successfully.
You can now proceed with the next steps.`
      },
      rejected: {
        title: "❌ Application Rejected",
        color: "text-red-600",
        bg: "bg-red-50 border-red-200",
        message: `We regret to inform you that your application has been rejected.
Please review your details and submit the application again.`
      }
    };

    const current = statusConfig[status];

    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className={`bg-white max-w-xl w-full rounded-2xl shadow-lg p-8 text-center border ${current.bg}`}>

          <h2 className={`text-2xl font-bold mb-4 ${current.color}`}>
            {current.title}
          </h2>

          <p className="text-gray-700 leading-relaxed whitespace-pre-line">
            {current.message}
          </p>

          {/* Optional: show admin reason if rejected */}
          {status === "rejected" && previewData?.rejectReason && (
            <div className="mt-4 text-sm text-red-500">
              Reason: {previewData.rejectReason}
            </div>
          )}

          {/* Edit button only if rejected */}
          {status === "rejected" && (
            <button
              onClick={() => setPreviewData(null)}
              className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Edit & Resubmit
            </button>
          )}

        </div>
      </div>
    );
  }





  const formatDate = (date) => {
    if (!date) return "N/A";

    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const sections = [
    { id: "basicProfile", label: "Basic Profile", icon: <User size={18} /> },
    { id: "contact", label: "Contact Info", icon: <FaPhone size={18} /> },
    { id: "passport", label: "Passport Details", icon: <FaPassport size={18} /> },
    { id: "canada", label: "Canada Info", icon: <FaFlag size={18} /> },
    { id: "visa", label: "Visa Application", icon: <FaFileAlt size={18} /> },
    { id: "flight", label: "Flight Booking", icon: <FaPlaneArrival size={18} /> },
    { id: "marital", label: "Marital Details", icon: <FaRing size={18} /> },
    { id: "child", label: "Child Details", icon: <FaChildren size={18} /> },
    { id: "parents", label: "Parents Details", icon: <FaUsers size={18} /> },
    { id: "siblings", label: "Siblings Details", icon: <FaUserFriends size={18} /> },
    { id: "education", label: "Education", icon: <FaGraduationCap size={18} /> },
    { id: "employment", label: "Employment", icon: <FaBriefcase size={18} /> },
    { id: "addresses", label: "Address History", icon: <FaHome size={18} /> },
    { id: "travel", label: "Travel Records", icon: <FaGlobe size={18} /> },
    { id: "criminal", label: "Criminal Records", icon: <FaShieldAlt size={18} /> },
    { id: "medical", label: "Medical History", icon: <FaHeartbeat size={18} /> },
    { id: "political", label: "Political", icon: <FaBalanceScale size={18} /> },
    { id: "local", label: "Local Authority", icon: <FaLandmark size={18} /> },
    { id: "statements", label: "Declarations", icon: <FaCommentDots size={18} /> },
  ];

  const currentIndex = Math.max(
    0,
    sections.findIndex(s => s.id === activeTab)
  );

  const handleSave = async () => {
    try {
      setLoading(true);

      // Helper function to safely format dates
      const formatDateForAPI = (date) => {
        if (!date) return null;
        if (typeof date === 'string') return date;
        if (date instanceof Date) return date.toISOString().split('T')[0];
        return null;
      };

      // Helper to process criminal/medical details
      const processDetailsArray = (formObj, detailsObj) => {
        const result = [];
        const types = Object.keys(detailsObj || {});

        types.forEach(type => {
          const detail = detailsObj[type];
          // Only include if the parent boolean is true AND we have data
          if (formObj[type] && detail) {
            result.push({
              type,
              date: detail.date || null,
              reason: detail.reason || "",
              result: detail.result || ""
            });
          }
        });

        return result;
      };

      const payload = {
        BasicProfile: {
          name: formData.name || "",
          surname: formData.surname || "",
          dateOfBirth: formatDateForAPI(formData.dateOfBirth),
          placeOfBirth: formData.placeOfBirth || "",
          citizenship: formData.citizenship || "",
          otherCitizenship: {
            hasOther: formData.otherCitizen === "Yes",
            country: formData.otherCitizen === "Yes" ? (formData.otherCountry || "") : null
          },
          motherTongue: formData.motherTongue || "",
          religion: formData.religion || "",
          caste: formData.casteImageUrl || "",
          gender: formData.gender || "prefer_not_to_say",
          heightInInch: formData.height ? parseInt(formData.height) : null
        },

        contact: {
          indiaAddress: formData.indiaAddress || "",
          canadaAddress: formData.canadaAddress || "",
          email: formData.email || "",
          countryCodes: formData.countryCodes || "+1",
          mobile: formData.mobile || "",
        },

        passport: {
          passportNumber: formData.passportNumber || "",
          dateOfIssue: formatDateForAPI(formData.dateOfIssue),
          dateOfExpiry: formatDateForAPI(formData.dateOfExpiry),
          placeOfIssue: formData.placeOfIssue || "",
        },

        marital: {
          maritalStatus: formData.maritalStatus || "single", // Provide default
          dateOfMarriage: formatDateForAPI(formData.dateOfMarriage),
          separationOrDeathDate: formatDateForAPI(formData.separationOrDeathDate),
        },

        // Process addresses (ensure all required fields have values)
        addresses: addresses.filter(addr => addr.address && addr.country).map(addr => ({
          address: addr.address || "",
          country: addr.country || "",
          from: formatDateForAPI(addr.from),
          to: formatDateForAPI(addr.to)
        })),

        // Process visas
        canada: canada.filter(v => v.appliedDate).map(v => ({
          appliedDate: v.appliedDate || "",
          appliedThrough: v.appliedThrough || "",
          agentName: v.agentName || "",
          howYouFoundAgent: v.howYouFoundAgent || "",
          feesPaid: v.feesPaid || "",
          biometricDate: v.biometricDate || "",
          biometricCity: v.biometricCity || "",
          issueDate: formatDateForAPI(v.issueDate),
          expiryDate: formatDateForAPI(v.expiryDate),
        })),

        // Process visas
        visas: visas.filter(v => v.country).map(v => ({
          country: v.country || "",
          visaType: v.visaType || "",
          issueDate: formatDateForAPI(v.issueDate),
          expiryDate: formatDateForAPI(v.expiryDate),
          denied: v.denied || false,
          denialReason: v.denied ? (v.denialReason || "") : ""
        })),

        // Process children
        childs: childs.filter(c => c.firstName).map(c => ({
          firstName: c.firstName || "",
          lastName: c.lastName || "",
          dob: formatDateForAPI(c.dob),
          gender: c.gender || "",
          education: c.education || "",
          currentCountry: c.currentCountry || "",
          isAccompanying: c.isAccompanying || false
        })),

        // Process parents
        parents: parents.filter(p => p.name).map(p => ({
          relation: p.relation || "",
          name: p.name || "",
          surname: p.surname || "",
          dateOfBirth: formatDateForAPI(p.dateOfBirth),
          dateOfDeath: formatDateForAPI(p.dateOfDeath),
          placeOfBirth: p.placeOfBirth || "",
          currentAddress: p.currentAddress || "",
          isInCanada: p.isInCanada || false,
          canadaAddress: p.isInCanada ? (p.canadaAddress || "") : null
        })),

        // Process siblings
        sibling: siblings.filter(s => s.name).map(s => ({
          relation: s.relation || "",
          name: s.name || "",
          surname: s.surname || "",
          maritalStatus: s.maritalStatus || "",
          dateOfBirth: formatDateForAPI(s.dateOfBirth),
          dateOfDeath: formatDateForAPI(s.dateOfDeath),
          placeOfBirth: s.placeOfBirth || "",
          currentAddress: s.currentAddress || "",
          isInCanada: s.isInCanada || false,
          canadaAddress: s.isInCanada ? (s.canadaAddress || "") : null
        })),

        // Process education
        educations: education.filter(e => e.level && e.schoolName).map(e => ({
          level: e.level || "",
          schoolName: e.schoolName || "",
          city: e.city || "",
          country: e.country || "",
          address: e.address || "",
          from: formatDateForAPI(e.from),
          to: formatDateForAPI(e.to)
        })),

        // Process work
        work: workList.filter(w => w.companyName).map(w => ({
          companyName: w.companyName || "",
          job: w.job || "",
          position: w.position || "",
          city: w.city || "",
          country: w.country || "",
          companyAddress: w.companyAddress || "",
          from: formatDateForAPI(w.from),
          to: formatDateForAPI(w.to)
        })),

        // Process flights
        flights: flights.filter(f => f.fromAirport || f.toAirport).map(f => ({
          fromAirport: f.fromAirport || "",
          toAirport: f.toAirport || "",
          airline: f.airline || "",
          ticketNumber: f.ticketNumber || "",
          transit: f.transit || "",
          airportCharges: f.airportCharges ? parseFloat(f.airportCharges) : null
        })),

        // Process travels
        travels: travels.filter(t => t.country).map(t => ({
          country: t.country || "",
          visaType: t.visaType || "",
          stayAddress: t.stayAddress || "",
          from: formatDateForAPI(t.from),
          to: formatDateForAPI(t.to)
        })),

        // Process criminality - ONLY include details for true booleans
        criminalitySecurity: {
          committedCrime: form.committedCrime || false,
          arrestedForOffence: form.arrestedForOffence || false,
          chargedForOffence: form.chargedForOffence || false,
          convictedForOffence: form.convictedForOffence || false,
          criminalDetails: processDetailsArray(form, form.criminalDetails)
        },

        // Process medical - ONLY include details for true booleans
        madicalHistory: {
          hasSeriousIllness: medical.hasSeriousIllness || false,
          hasMentalDisorder: medical.hasMentalDisorder || false,
          hasCommunicableDisease: medical.hasCommunicableDisease || false,
          requiresMedicalTreatment: medical.requiresMedicalTreatment || false,
          medicalDetails: processDetailsArray(medical, medical.medicalDetails)
        },

        // Process political
        politicalAffiliation: {
          supportedPartyYesNo: political.supportedPartyYesNo || false,
          supportedPartyName: political.supportedPartyYesNo ? (political.supportedPartyName || "") : "",
          farmerOrgYesNo: political.farmerOrgYesNo || false,
          farmerOrganisation: political.farmerOrgYesNo ? (political.farmerOrganisation || "") : "",
          proKhalistanYesNo: political.proKhalistanYesNo || false,
          proKhalistanSupport: political.proKhalistanYesNo ? (political.proKhalistanSupport || "") : ""
        },

        // Process local authority
        localAuthority: {
          sarpanchOrMLA: local.sarpanchOrMLA || "",
          partyName: local.partyName || "",
          partyOfficeAddress: local.partyOfficeAddress || "",
          policeASI: local.policeASI || "",
          policeHawaldar: local.policeHawaldar || "",
          nearbyHospital: local.nearbyHospital || "",
          stateGovernment: {
            party: local.stateGovernment?.party || "",
            cmName: local.stateGovernment?.cmName || ""
          }
        },

        // Process statements and narratives
        statements: statements.filter(s => s.language && s.description).map(s => ({
          language: s.language,
          description: s.description,
          files: (s.files || []).map(f => ({
            url: f.url,
            fileName: f.fileName,
            uploadedAt: new Date()
          }))
        })),

        narratives: narratives.filter(n => n.language && n.description).map(n => ({
          language: n.language,
          description: n.description,
          files: (n.files || []).map(f => ({
            url: f.url,
            fileName: f.fileName,
            uploadedAt: new Date()
          }))
        })),

        // Process old passports - IMPORTANT: only include if hasOldPassport is true
        oldPassports: (() => {
          const hasOldPassport = oldPassports.hasOldPassport || false;
          const validPassports = (oldPassports.passports || []).filter(p => p.passportNumber);

          if (!hasOldPassport || validPassports.length === 0) {
            return {
              hasOldPassport: false,
              passports: []
            };
          }

          return {
            hasOldPassport: true,
            passports: validPassports.map(p => ({
              passportNumber: p.passportNumber,
              issueDate: formatDateForAPI(p.issueDate),
              expiryDate: formatDateForAPI(p.expiryDate),
              remarks: p.remarks || ""
            }))
          };
        })()
      };

      console.log("Sending payload:", JSON.stringify(payload, null, 2));

      const res = await makeRequestAuth("post", "/user/createOrUpdateSpouse", payload);

      showSuccessToast("Form saved successfully ✅");

      // Optionally reset editing state after save
      if (setPreviewData) {
        setPreviewData(payload);
      }

    } catch (err) {
      console.error("Save error:", err);
      console.error("Error response:", err?.response?.data);
      showErrorToast(
        err?.response?.data?.message || "Failed to save form ❌"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col md:flex-row">

      {/* --- Mobile Header --- */}
      <div className="md:hidden bg-white border-b px-4 py-3 sticky top-0 z-50 flex justify-between items-center">
        <h2 className="text-lg font-bold text-blue-600">Spouse App</h2>
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 bg-gray-100 rounded-md"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* --- Sidebar (Desktop) & Overlay Menu (Mobile) --- */}
      <div className={`
        ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0 fixed md:relative z-40 w-72 md:w-64 h-full bg-white border-r 
        transition-transform duration-300 ease-in-out overflow-y-auto
      `}>
        <div className="p-5">
          <h2 className="hidden md:block text-xl font-bold text-blue-600 mb-6">
            Spouse Application
          </h2>

          <nav className="space-y-1">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => handleTabChange(section.id)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium w-full transition-all ${activeTab === section.id
                  ? "bg-blue-600 text-white shadow-md shadow-blue-200"
                  : "text-gray-600 hover:bg-gray-100"
                  }`}
              >
                <span className={activeTab === section.id ? "text-white" : "text-blue-500"}>
                  {section.icon}
                </span>
                {section.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* --- Main Content Area --- */}
      <main className="flex-1 p-4 md:p-8 lg:p-12 overflow-x-hidden">
        <div className="max-w-4xl mx-auto">

          {/* Progress Indicator (Optional but helpful) */}
          <div className="mb-6 flex items-center gap-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">
            <span>Spouse</span>
            <span>/</span>
            <span className="text-blue-600">{sections.find(s => s.id === activeTab)?.label}</span>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 md:p-8">
            <header className="mb-8">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                {sections.find((s) => s.id === activeTab)?.label}
              </h1>
              <p className="text-gray-500 mt-1 text-sm md:text-base">
                Please provide accurate information for your {sections.find((s) => s.id === activeTab)?.label.toLowerCase()}.
              </p>
            </header>

            {/* Form Sections */}
            <div className="transition-opacity duration-300">
              {activeTab === "basicProfile" && (
                <BasicProfileForm
                  previewData={previewData}
                  setPreviewData={setPreviewData}
                  loading={loading}
                  errors={errors}
                  formData={formData}
                  handleChange={handleChange}
                  setFormData={setFormData}
                  handleUpload={handleUpload}
                  formatDate={formatDate}
                />
              )}

              {activeTab === "contact" && (
                <ContactForm
                  loading={loading}
                  errors={errors}
                  preview={previewData}
                  handleChange={handleChange}
                  formData={formData}
                />
              )}

              {activeTab === "passport" && (
                <PassportForm
                  preview={previewData}
                  formData={formData}
                  handleChange={handleChange}
                  loading={loading}
                  errors={errors}
                  formatDate={formatDate}
                />
              )}

              {activeTab === "canada" && (
                <CanadaForm
                  visas={canada}
                  setVisas={setCanada}
                  preview={previewData}
                  setPreview={setPreviewData}
                  handleChange={handleChange}
                  loading={loading}
                  errors={errors}
                  formatDate={formatDate}
                  getEmptyVisa={getEmptyVisa}
                />
              )}

              {activeTab === "visa" && (
                <VISAForm
                  visas={visas}
                  setVisas={setVisas}
                  oldPassports={oldPassports}
                  setOldPassports={setOldPassports}
                  preview={previewData}
                  setPreview={setPreviewData}
                  handleVisaChange={handleVisaChange}
                  handleOldPassportChange={handleOldPassportChange}
                  loading={loading}
                  emptyVisa={emptyVisa}
                  emptyPassport={emptyPassport}
                />
              )}

              {activeTab === "flight" && (
                <FlightForm
                  flights={flights}
                  setFlights={setFlights}
                  createEmptyFlight={createEmptyFlight}
                  preview={previewData}
                  setPreview={setPreviewData}
                  loading={loading}
                  errors={errors}
                  handleChange={handleFlightsChange}
                />
              )}

              {activeTab === "marital" && (
                <MaritalForm
                  formData={formData}
                  preview={previewData}
                  setPreview={setPreviewData}
                  handleChange={handleChange}
                  loading={loading}
                  errors={errors}
                />
              )}

              {activeTab === "child" && (
                <ChildForm
                  childs={childs}
                  setChilds={setChilds}
                  createEmptyChild={createEmptyChild}
                  updateChild={updateChild}
                  loading={loading}
                  mode={mode}
                />
              )}

              {activeTab === "parents" && (
                <ParentForm
                  parents={parents}
                  setParents={setParents}
                  updateParent={updateParent}
                  mode={mode}
                  createEmptyParent={createEmptyParent}
                  loading={loading}
                />
              )}

              {activeTab === "siblings" && (
                <SiblingForm
                  siblings={siblings}
                  setSiblings={setSiblings}
                  createEmptySibling={createEmptySibling}
                  previewMode={previewData}
                  handleChange={handleSiblingsChange}
                />
              )}

              {activeTab === "education" && (
                <EducationForm
                  education={education}
                  setEducation={setEducation}
                  getEmptyEducation={getEmptyEducation}
                  preview={previewData}
                  handleChange={handleEducationChange}
                  loading={loading}
                  errors={errors}
                />
              )}

              {activeTab === "employment" && (
                <EmploymentFrom
                  workList={workList}
                  setWorkList={setWorkList}
                  getEmptyWork={getEmptyWork}
                  preview={previewData}
                  handleChange={handleEmploymentChange}
                  errors={errors}
                />
              )}

              {activeTab === "addresses" && (
                <AddressHistoryForm
                  addresses={addresses}
                  setAddresses={setAddresses}
                  getEmptyAddress={getEmptyAddress}
                  preview={previewData}
                  handleChange={handleAddressHistoryChange}
                  loading={loading}
                  errors={errors}
                />
              )}

              {activeTab === "travel" && (
                <TravelForm
                  travels={travels}
                  setTravels={setTravels}
                  EMPTY_TRAVEL={EMPTY_TRAVEL}
                  preview={previewData}
                  handleChange={handleTravelChange}
                  loading={loading}
                  errors={errors}
                />
              )}

              {activeTab === "criminal" && (
                <CriminalitySecurityForm
                  form={form}
                  preview={previewData}
                  handleChange={handleCriminalityChange}
                  handleDetailChange={handleCriminalityDetailChange}
                  loading={loading}
                />
              )}

              {activeTab === "medical" && (
                <MedicalHistoryForm
                  form={medical}
                  preview={previewData}
                  handleChange={handleMedicalChange}
                  handleDetailChange={handleDetailMedicalChange}
                  loading={loading}
                />
              )}

              {activeTab === "political" && (
                <PoliticalForm
                  formData={political}
                  preview={previewData}
                  handleChange={handlePoliticalChange}
                  loading={loading}
                  errors={errors}
                />
              )}

              {activeTab === "local" && (
                <LocalForm
                  data={local}
                  preview={previewData}
                  handleChange={handleLocalChange}
                  handleStateGovChange={handleStateGovLocalChange}
                  loading={loading}
                  errors={errors}
                />
              )}

              {activeTab === "statements" && (
                <StatementForm
                  statements={statements}
                  setStatements={setStatements}
                  narratives={narratives}
                  setNarratives={setNarratives}
                  eSignatureText={eSignatureText}
                  setESignatureText={setESignatureText}
                  signatureUrl={signatureUrl}
                  signatureUploading={signatureUploading}
                  getEmptyBlock={getEmptyBlock}
                  preview={previewData}
                  uploadSignature={uploadSignature}
                  updateList={updateList}
                  handleFileUpload={handleFileUpload}
                  loading={loading}
                />
              )}








              {/* Other tabs follow the same pattern */}
            </div>

            {/* Navigation Buttons inside Content */}
            <div className="mt-10 pt-6 border-t flex justify-between items-center">
              <button
                className="px-6 py-2 text-gray-600 font-medium hover:bg-gray-100 rounded-lg transition-colors"
                disabled={activeTab === "basicProfile"}
                onClick={() => {
                  const idx = sections.findIndex(s => s.id === activeTab);
                  handleTabChange(sections[idx - 1].id);
                }}
              >
                Previous
              </button>
              <button
                className="px-8 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all"
                onClick={() => {
                  if (currentIndex < sections.length - 1) {
                    handleTabChange(sections[currentIndex + 1].id);
                  } else {
                    handleSave(); // ✅ LAST STEP SAVE
                  }
                }}
              >
                {currentIndex < sections.length - 1 ? "Next" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Overlay for Mobile Sidebar */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-30 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default SpouseForm;